/** * 系统管理 角色管理 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input
          size="small"
          v-model="searchKey"
          placeholder="输入部门名称"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="">
        <el-input size="small" v-model="formInline.roleNo" placeholder="输入角色代码"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getdata(1)"
          >搜索</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleEdit()"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;"
    >
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column sortable prop="rolesName" label="部门名称" width="300">
      </el-table-column>
      <!-- <el-table-column sortable prop="roleNo" label="角色代码" width="300">
      </el-table-column> -->
      <!-- <el-table-column sortable prop="editTime" label="修改时间" width="300">
        <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template>
      </el-table-column> -->
      <el-table-column sortable prop="createTime" label="创建时间" width="300">
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
      </el-table-column> -->
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="deleteUser(scope.$index, scope.row)"
            >删除</el-button
          >
          <!-- <el-button size="mini" type="success" @click="menuAccess(scope.$index, scope.row)">菜单权限</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      width="30%"
      @click="closeDialog('edit')"
    >
      <el-form label-width="120px" ref="editForm">
       
        <el-form-item label="部门名称" prop="roleName">
          <el-input
            size="small"
            v-model="rolesName"
            auto-complete="off"
            placeholder="请输入部门名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="部门权限" prop="roleName">
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="数据管理-数据统计"></el-checkbox>
            <el-checkbox label="用户管理-用户列表"></el-checkbox>
            <el-checkbox label="广告管理-开屏广告列表"></el-checkbox>
            <el-checkbox label="订单管理-商品订单列表"></el-checkbox>
            <el-checkbox label="订单管理-充值记录列表"></el-checkbox>
            <el-checkbox label="订单管理-余额明细列表"></el-checkbox>
            <el-checkbox label="订单管理-为学学院充值记录"></el-checkbox>
            <el-checkbox label="商品管理-商品列表"></el-checkbox>
            <el-checkbox label="平台管理-实名认证"></el-checkbox>
            <el-checkbox label="平台管理-系统用户"></el-checkbox>
            <el-checkbox label="平台管理-角色管理"></el-checkbox>
            <el-checkbox label="平台管理-评论管理"></el-checkbox>
            <el-checkbox label="平台管理-用户反馈"></el-checkbox>
            <el-checkbox label="平台管理-提现列表"></el-checkbox>
            <el-checkbox label="平台管理-基础设置"></el-checkbox>
            <el-checkbox label="分类管理-分类列表"></el-checkbox>
            <el-checkbox label="作品管理-作品列表"></el-checkbox>
            <el-checkbox label="活动管理-活动列表"></el-checkbox>
            <el-checkbox label="报名记录-家教报名记录"></el-checkbox>
            <el-checkbox label="报名记录-家长报名记录 "></el-checkbox>
            <el-checkbox label="放映厅管理-放映厅列表"></el-checkbox>
            <el-checkbox label="放映厅管理-放映厅购买列表"></el-checkbox>
            <el-checkbox label="金字塔管理-金字塔列表"></el-checkbox>
            <el-checkbox label="圈层管理-圈层列表"></el-checkbox>
            <el-checkbox label="圈层管理-圈层申请列表"></el-checkbox>
            <el-checkbox label="课程管理-课程标签列表"></el-checkbox>
            <el-checkbox label="课程管理-用户课程列表"></el-checkbox>
            <el-checkbox label="课程管理-平台课程列表"></el-checkbox>
            <el-checkbox label="教培机构管理"></el-checkbox>
            <el-checkbox label="商家服务"></el-checkbox>
            <el-checkbox label="自习室管理"></el-checkbox>
            <el-checkbox label="字典配置"></el-checkbox>
            <el-checkbox label="拉新配置管理-拉新配置列表"></el-checkbox>
            <el-checkbox label="卡密管理-卡密批次列表"></el-checkbox>
            <el-checkbox label="卡密管理-卡密列表"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('edit')">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="addRoles()"
          v-if="title == '添加'"
          >添加</el-button
        >
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="upRoles()"
          v-if="title == '修改'"
          >修改</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addRoles, upRoles, deleteRoles, getRolesList } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      id: "", //当前操作的id
      searchKey: "", //搜索的关键字
      rolesName: "", //角色名字
      checkList: [], //权限列表
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      menuAccessshow: false, //控制数据权限显示与隐藏
      title: "添加",
      // 删除
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken")
      },

      listData: [], //用户数据
      // 选中
      checkmenu: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    };
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    this.getdata(1);
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    // 添加角色
    addRoles(page) {
      this.loading = true;
      addRoles({
        rolesName: this.rolesName,
        permission: JSON.stringify(this.checkList)
      }).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getdata(1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 修改角色
    upRoles(page) {
      this.loading = true;
      upRoles({
        rolesName: this.rolesName,
        permission: JSON.stringify(this.checkList),
        id: this.id
      }).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getdata(1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 获取数据方法
    getdata(page) {
      this.editFormVisible = false;
      this.loading = true;
      // page = (page - 1) * 20;
      // 获取用户列表
      var parameter = {
        rolesName: this.searchKey,
        page: (page - 1) * 20
      };
      getRolesList(parameter).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          // 分页赋值
          this.pageparm.currentPage = page;
          this.pageparm.total = res.data.count;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg
        });
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(parm.currentPage);
    },

    //显示编辑界面
    handleEdit: function(row) {
      console.log("row", row);
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.id = row.id;
        this.checkList = JSON.parse(row.permission);
        this.rolesName = row.rolesName;
      } else {
        this.title = "添加";
        this.checkList = [];
        this.rolesName = "";
      }
    },

    // 删除角色
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteRoles({ id: row.id })
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "角色已删除！"
                });
                this.getdata(1);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg
                });
              }
            })
            .catch(err => {
              this.loading = false;
              this.$message.error("角色删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == "edit") {
        this.editFormVisible = false;
      } else if (dialog == "perm") {
        this.menuAccessshow = false;
      }
    }
  }
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/terrace/Role.vue